<template>
    <v-chip-group class="flex-wrap">
        <v-chip large color="grey-light" text-color="grey-dark" v-for="item in items" :key="item"><span class="font-weight-regular">{{ item }}</span></v-chip>
    </v-chip-group>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: {
    spaces: { type: Array, default: () => [] },
    schedules: { type: Array, default: () => [] },
  },
  data: () => ({}),
  computed: {
    items() {
      return this.schedules.map((schedule) =>
        schedule.isWholeDayRent
          ? undefined
          : dayjs(schedule.date)
              .set("hour", schedule.time)
              .format("YY년 M월 D일 HH시")
      );
    },
  },
};
</script>
